module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "afor",
      "title": "Foreword"
    }
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#for"
    }
  }, [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#for"
    }
  }, [_vm._v("BY JOHN BIRDSALL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "bro"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("E TEND TO THINK")])]), _vm._v(" of a cuisine as a monolithic thing, hewn from rock by ancient hands and hauled by some other generation long ago into the present, for us to passively inherit. Take cassoulet, for example. In all its local variations, it is a dish most Americans reckon as fixed in French tradition, locked in a rustic past we can’t really imagine. It no longer feels like a living dish, capable of being fully modern. It’s an expression of cultural nostalgia, honoring a history whose arc ended before we were born. By contrast, Filipino food—the cooking born in the island archipelago—is being carried around the world by hands that are still working and adapting their inherited culinary knowledge; Filipino food is as dynamic and fluid as molten lava, morphing to both fit and transform landscapes far from the Philippines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book of recipes—each framed by a story of discovery and reinvention—is an act of a global cuisine in the making. It’s proof that cooking is a living art. Like language, it’s constantly changing as its practitioners adapt to new places, new realities.")]), _vm._v(" "), _c('p', {
    staticClass: "ch-txt"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Like language, the art of cooking is constantly changing as its practitioners adapt to new places, new realities.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My own introduction to Filipino food came in the form of a dish my future mother-in-law made me, many years ago, on a sweltering morning in Chicago. I’d flown there from San Francisco with my new boyfriend, who had only just come out to his Ilocano parents. We’d arrived late the night before—I barely had time to exchange awkward hellos with Perry’s parents before they went off to bed. The next morning, as Perry slept, I made my way to the kitchen, where his mom, Prespedina, was watching "), _c('i', [_vm._v("Oprah")]), _vm._v(" on a little TV set. The awkwardness of the night before was still there; it was a presence even more commanding than Oprah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prespedina offered me breakfast. I could have cereal, she said, or—if I wanted to—I could try “our food,” as she called it: a bowl of chocolate meat. She giggled a little when she said it. Perry had told me about chocolate meat, or dinuguan. I knew that it was made with pork blood and offal. And I knew, by the way Prespedina asked, that I had to try it.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "534",
      "src": "images/f00ix-01.jpg",
      "width": "437"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was delicious, rich, bright with vinegar—it had soul. It represented the new realities both Prespedina and I were adapting to that morning: she, to having a gay son who had brought his boyfriend home; me, to trying a new cuisine that seemed to express both yearning for a distant homeland and an adaptation to a place of trees, sweeping green lawns, and neighbors who were mostly Irish American. On that now-distant morning, a Filipino dish was more than an expression of nostalgia. It was a single brick in the building of a new world.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents1"
  }, [_c('b', [_vm._v("John Birdsall")]), _vm._v(" is the author of the forthcoming book "), _c('i', [_vm._v("James Beard: The Man Who Ate Too Much")]), _vm._v(". He won the James Beard Award for food and culture writing in 2014 and 2016.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db499abc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Foreword.vue
// module id = 72
// module chunks = 0